import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import cls from 'classnames/bind';

import Week from '../Week/Week';

import s from './Month.scss';

const cx = cls.bind(s);
class Month extends PureComponent {
  static propTypes = {
    weeks: PropTypes.array,

    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    hoveredDate: PropTypes.instanceOf(Date),

    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    maxDays: PropTypes.number,

    pickOneDate: PropTypes.bool,

    title: PropTypes.string,
    hasCompactTitle: PropTypes.bool,
    year: PropTypes.number,

    showYear: PropTypes.bool, // здесь используется, чтобы выводить год рядом с месяцем
    endOnlyAfterStart: PropTypes.bool,
    heatmap: PropTypes.shape({
      currency: PropTypes.string.isRequired,
      min: PropTypes.number.isRequired,
      mid: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
      time: PropTypes.number.isRequired,
      prices: PropTypes.PropTypes.object.isRequired,
    }),
    heatmapStatus: PropTypes.shape({
      initial: PropTypes.bool.isRequired,
      loading: PropTypes.bool.isRequired,
      success: PropTypes.bool.isRequired,
      error: PropTypes.bool.isRequired,
      cancelled: PropTypes.bool.isRequired,
    }),
    withHeatmap: PropTypes.bool,
    showHeatmapPrices: PropTypes.bool,
    checkIfDateIsDisabled: PropTypes.func,

    onDateSelect: PropTypes.func,
    onDateHover: PropTypes.func,

    getTooltipContent: PropTypes.func,
    tooltipIsAvailable: PropTypes.bool,
  };

  static defaultProps = {
    hasCompactTitle: false,
    showYear: false,
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  getWeekNode(date) {
    const { weeks } = this.props;
    const dateDay = date.getDate();
    const weekIndex = weeks.findIndex((week) => week.some((day) => day.day === dateDay));
    return this.refs[`week_${weekIndex ? weekIndex - 1 : weekIndex}`];
  }

  render() {
    const {
      weeks,
      title,
      hasCompactTitle,
      endOnlyAfterStart,
      checkIfDateIsDisabled,
      year,
      ...weekProps
    } = this.props;

    return (
      <div className={cx('Month')}>
        <div className={cx('title-wrap', { 'title-wrap--compact': hasCompactTitle })}>
          <span className={cx('title')}>
            {title}

            {year && <span className={cx('year')}>&nbsp;{year}</span>}
          </span>
        </div>

        {weeks.map((week, i) => {
          return (
            <Week
              ref={`week_${i}`}
              days={week}
              endOnlyAfterStart={endOnlyAfterStart}
              checkIfDateIsDisabled={checkIfDateIsDisabled}
              {...weekProps}
              key={i}
            />
          );
        })}
      </div>
    );
  }
}

export default Month;
